// C:\MonProjet\BBW_DELEGUER\prod\babyworld-backoffice\babyworld-backoffice\src\router\index.js

import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import Main from "../components/layout/Main";
import ProtectedRoute from "../components/ProtectedRoute";

import "antd/dist/reset.css";
import "../assets/styles/main.css";
import "../assets/styles/responsive.css";

import SignIn from '../pages/SignInPage';
import UnauthorizedPage from "../pages/UnauthorizedPage";
import DoctorsPage from "../pages/doctors/DoctorsPage";
import AddDoctorPage from "../pages/doctors/AddDoctorPage";
import EditDoctorPage from "../pages/doctors/EditDoctorPage";
import ArchivedDoctorsPage from "../pages/doctors/ArchivedDoctorsPage";
import PharmaciesPage from "../pages/pharmaciens/PharmaciesPage";
import AddPharmaciesPage from "../pages/pharmaciens/AddPharmaciesPage";
import EditPharmaciesPage from "../pages/pharmaciens/EditPharmaciesPage";
import GrossistesPage from "../pages/wholesalers/GrossistesPage";
import AddGrossistesPage from "../pages/wholesalers/AddGrossistesPage";
import EditGrossistesPage from "../pages/wholesalers/EditGrossistesPage";
import SpecialtiesPage from "../pages/specialties/SpecialtiesPage";
import AddSpecialtiesPage from "../pages/specialties/AddSpecialtiesPage";
import EditSpecialtiesPage from "../pages/specialties/EditSpecialtiesPage";
import RegionPage from "../pages/regions/RegionPage";
import AddRegionPage from "../pages/regions/AddRegionPage";
import EditRegionPage from "../pages/regions/EditRegionPage";
import ProductPage from "../pages/product";
import AddProductPage from "../pages/product/AddProductPage";
import EditProductPage from "../pages/product/EditProductPage";
import SamplesPage from "../pages/samples";
import AddSamplePage from "../pages/samples/AddSamplesPage";
import EditSamplePage from "../pages/samples/EditSamplesPage";
import UsersPage from "../pages/users/UsersPage";
import AddUsersPage from "../pages/users/AddUsersPage";
import EditUsersPage from "../pages/users/EditUsersPage";
import DelegatesPage from "../pages/delegates/DelegatesPage";
import AddDelegatesPage from "../pages/delegates/AddDelegatesPage";
import EditDelegatesPage from "../pages/delegates/EditDelegatesPage";
import AssignedListDelegatesPage from "../pages/delegates/AssignedListDelegatesPage";
import AssignPersonsPage from "../pages/delegates/AssignPersonsPage";
import RapportsPage from "../pages/rapports";
import VisitesParticulieresPage from "../pages/visites-particulieres"; 
import Reportdetails from "../pages/rapports/reportdetails";
import VisitManagementPage from "../pages/visites/VisitManagementPage";
import MissedVisitsPage from "../pages/visites/MissedVisitsPage";
import GivenSamplesSummaryPage from "../pages/givenSamplesSummary";
import CyclesPage from '../pages/planning/CyclesPage';
import PublicHolidaysPage from '../pages/planning/PublicHolidaysPage';
import DelegateLeavesPage from '../pages/planning/DelegateLeavesPage';
import PhysicianReturnIndexPage from "../pages/analytics/ReturnIndexPage";
import RolesPage from "../pages/roles/RolesPage";
import AuditLogPage from "../pages/audit/AuditLogPage";
import DelegatesSummaryPage from "../pages/analytics/DelegatesSummaryPage";
import SupervisorsPage from "../pages/supervisors/SupervisorsPage";
import AssignDelegatesToSupervisorPage from "../pages/supervisors/AssignDelegatesToSupervisorPage";
import AddSupervisorPage from "../pages/supervisors/AddSupervisorPage";
import RapportsDoublonsPage from "../pages/rapports/doublons";
import SupervisorReportsPage from "../pages/rapports/SupervisorReportsPage";
import WeeklyMissedVisitsPage from "../pages/analytics/WeeklyMissedVisitsPage";
import CorrectionRequestsPage from "../pages/admin/CorrectionRequestsPage";
import SuggestionRapportsPage from "../pages/admin/SuggestionRapportsPage";
import SettingsPage from "../pages/settings/SettingsPage"; 
import EmergencyReportPage from "../pages/delegate-emergency/EmergencyReportPage"; 

import StocksManagementPage from "../pages/stocks/StocksManagementPage"; 
import SampleSpecialtyConfig from "../pages/samples/SampleSpecialtyConfig";
import StocksDashboard from "../pages/stocks/StocksDashboard";

import MarketingCampaignsPage from "../pages/marketing/MarketingCampaignsPage";
import ProductSummaryPage from "../pages/product/ProductSummaryPage";
import EventsPage from "../pages/planning/EventsPage";

import MaterniteReportPage from "../pages/maternite/MaterniteReportPage";
import ClinicReportsPage from "../pages/rapports-cliniques"; 
import ClinicStatsPage from "../pages/analytics/ClinicStatsPage";
import DashboardPage from '../pages/dashboard/DashboardPage';

import SupervisorControlReportPage from '../pages/supervisors/SupervisorControlReportPage';
// TunisiaMap supprimé d'ici

const protectedRoutes = [
  { path: "/médecins", component: DoctorsPage, permission: "pages:doctors:view" },
  { path: "/médecins/archives", component: ArchivedDoctorsPage, permission: "pages:doctors:view" },
  { path: "/nouveau/médecin", component: AddDoctorPage, permission: "api:persons:create" },
  { path: "/edit/médecin/:id", component: EditDoctorPage, permission: "api:persons:edit" },
  { path: "/pharmacies", component: PharmaciesPage, permission: "pages:pharmacies:view" },
  { path: "/nouvelle/pharmacie", component: AddPharmaciesPage, permission: "api:persons:create" },
  { path: "/edit/pharmacie/:id", component: EditPharmaciesPage, permission: "api:persons:edit" },
  { path: "/grossistes", component: GrossistesPage, permission: "pages:wholesalers:view" },
  { path: "/nouveau/grossiste", component: AddGrossistesPage, permission: "api:persons:create" },
  { path: "/edit/grossiste/:id", component: EditGrossistesPage, permission: "api:persons:edit" },
  { path: "/spécialités", component: SpecialtiesPage, permission: "pages:specialties:view" },
  { path: "/nouvelle/spécialité", component: AddSpecialtiesPage, permission: "api:specialties:create" },
  { path: "/edit/spécialité/:id", component: EditSpecialtiesPage, permission: "api:specialties:edit" },
  { path: "/régions", component: RegionPage, permission: "pages:regions:view" },
  { path: "/nouvelle/région", component: AddRegionPage, permission: "api:regions:create" },
  { path: "/edit/région/:id", component: EditRegionPage, permission: "api:regions:edit" },
  { path: "/produit", component: ProductPage, permission: "pages:products:view" },
  { path: "/produit/resume", component: ProductSummaryPage, permission: "pages:products:view" },
  { path: "/nouveau/produit", component: AddProductPage, permission: "api:products:create" },
  { path: "/edit/produit/:id", component: EditProductPage, permission: "api:products:edit" },
  { path: "/samples", component: SamplesPage, permission: "pages:samples:view" },
  { path: "/nouveau/échantillon", component: AddSamplePage, permission: "api:samples:create" },
  { path: "/edit/sample/:id", component: EditSamplePage, permission: "api:samples:edit" },
  { path: "/ciblage-echantillons", component: SampleSpecialtyConfig, permission: "api:samples:edit" },
  { path: "/utilisateurs", component: UsersPage, permission: "users:view" },
  { path: "/nouveau/utilisateur", component: AddUsersPage, permission: "users:create" },
  { path: "/edit/utilisateur/:id", component: EditUsersPage, permission: "users:edit" },
  { path: "/délégués", component: DelegatesPage, permission: "delegates:view" },
  { path: "/nouveau/délégués", component: AddDelegatesPage, permission: "delegates:create" },
  { path: "/edit/délégué/:id", component: EditDelegatesPage, permission: "delegates:edit" },
  { path: "/assigné/délégué/:id", component: AssignedListDelegatesPage, permission: "delegates:assign" },
  { path: "/assigner/personne/:id", component: AssignPersonsPage, permission: "delegates:assign" },
  { path: "/gestion-stocks", component: StocksManagementPage, permission: "delegates:view" },
  { path: "/dashboard-stocks", component: StocksDashboard, permission: "analytics:view" },
  { path: "/rapports", component: RapportsPage, permission: "reports:view" },
  { path: "/visites-particulieres", component: VisitesParticulieresPage, permission: "reports:view" },
  { path: "/rapports-superviseurs", component: SupervisorReportsPage, permission: "reports:view" },
  { path: "/rapports/doublons", component: RapportsDoublonsPage, permission: "reports:delete" },
  { path: "/reportdetails/:id", component: Reportdetails, permission: "reports:view" },
  { path: "/visites", component: VisitManagementPage, permission: "visits:view" },
  { path: "/visites-manquees", component: MissedVisitsPage, permission: "visits:view" },
  { path: "/summary/given-samples", component: GivenSamplesSummaryPage, permission: "reports:view" },
  { path: "/planning/cycles", component: CyclesPage, permission: "planning:cycles:view" },
  { path: "/planning/holidays", component: PublicHolidaysPage, permission: "planning:holidays:view" },
  { path: "/planning/leaves", component: DelegateLeavesPage, permission: "planning:leaves:view" },
  { path: "/planning/evenements", component: EventsPage, permission: "planning:leaves:view" },
  { path: "/analytics/return-index", component: PhysicianReturnIndexPage, permission: "analytics:view" },
  { path: "/analytics/summary", component: DelegatesSummaryPage, permission: "analytics:view" },
  { path: "/analytics/weekly-missed-visits", component: WeeklyMissedVisitsPage, permission: "analytics:view" },
  { path: "/roles", component: RolesPage, permission: "roles:manage" },
  { path: "/audit-logs", component: AuditLogPage, permission: "audit:view" },
  { path: "/superviseurs", component: SupervisorsPage, permission: "supervisors:view" },
  { path: "/superviseur/:id/assigner-delegues", component: AssignDelegatesToSupervisorPage, permission: "supervisors:assign" },
  { path: "/nouveau/superviseur", component: AddSupervisorPage, permission: "supervisors:manage" },
  { path: "/admin/data-corrections/persons", component: CorrectionRequestsPage, permission: "data:manage" },
  { path: "/admin/data-corrections/reports", component: SuggestionRapportsPage, permission: "data:manage" },
  { path: "/settings", component: SettingsPage, permission: "roles:manage" },
  { path: "/marketing-actions", component: MarketingCampaignsPage, permission: "api:samples:edit" },
  { path: "/rapports-cliniques", component: ClinicReportsPage, permission: "web:maternite:access" },
  { path: "/stats-cliniques", component: ClinicStatsPage, permission: "analytics:view" },
  { path: "/maternite", component: MaterniteReportPage, permission: "web:maternite:access" },
  { path: "/emergency", component: EmergencyReportPage, permission: "reports:view" },
  { path: "/dashboard", component: DashboardPage, permission: "reports:view" },
  { path: "/superviseur/rapport-controle", component: SupervisorControlReportPage, permission: "reports:view" },
];

function Router() {
  const { user } = useSelector((state) => state.signin);

  if (!user) {
    return (
      <Switch>
        <Route exact path="/sign-in" component={SignIn} />
        <Redirect to="/sign-in" />
      </Switch>
    );
  }

  // 1. DÉFINITION TRÈS PRÉCISE DES RÔLES
  const roleName = user?.role?.name?.toLowerCase();
  const isAdmin = roleName === "admin" || roleName === "administrateur" || user?.role?.id === 1;
  const isDelegate = user?.role?.id === 3;
  const isCommercial = roleName === "comptable";
  const isMarketingComm = roleName === "marketingcommercial" || roleName === "marketingcommerciale"; 
  
  // Maternité seulement si ce n'est PAS un admin
  const isClinicDelegate = user?.permissions?.includes('web:maternite:access') && !isAdmin;

  const isSyrine = 
    user?.email?.toLowerCase().includes("syrine") || 
    user?.firstName?.toLowerCase().includes("syrine");

  const routesToRender = protectedRoutes.map(route => {
    if (route.path === "/rapports-superviseurs" && isSyrine) {
      return { ...route, permission: null }; // Débloque l'accès pour Syrine
    }
    return route;
  });

  return (
    <Switch>
      <Route exact path="/sign-in" component={SignIn} />
      
      {/* 2. LOGIQUE DE REDIRECTION RACINE (/) */}
      <Route exact path="/">
        {(() => {
          if (isAdmin) return <Redirect to="/rapports" />;
          if (isMarketingComm) return <Redirect to="/rapports-cliniques" />;
          if (isClinicDelegate) return <Redirect to="/maternite" />;
          if (isDelegate) return <Redirect to="/emergency" />;
          if (isCommercial) return <Redirect to="/analytics/summary" />;
          return <Redirect to="/rapports" />;
        })()}
      </Route>

      <Route>
        <Main>
          <Switch>
            {/* Pages Maternité */}
            <ProtectedRoute 
                path="/maternite" 
                component={isMarketingComm ? () => <Redirect to="/rapports-cliniques" /> : MaterniteReportPage} 
                requiredPermission="web:maternite:access" 
            />
            
            <ProtectedRoute path="/rapports-cliniques" component={ClinicReportsPage} requiredPermission="web:maternite:access" />
            <ProtectedRoute path="/stats-cliniques" component={ClinicStatsPage} requiredPermission="analytics:view" />
            <ProtectedRoute path="/emergency" component={EmergencyReportPage} requiredPermission="reports:view" />

            {/* Toutes les autres routes */}
            {protectedRoutes.map(({ path, component, permission }) => (
              <ProtectedRoute
                key={path}
                exact
                path={path}
                component={component}
                requiredPermission={permission}
              />
            ))}

            {/* Route cartographie supprimée d'ici */}
            
            <Route exact path="/unauthorized" component={UnauthorizedPage} />
            
            {/* CATCH-ALL */}
            <Route path="*">
               {(() => {
                  if (isAdmin) return <Redirect to="/rapports" />;
                  if (isMarketingComm) return <Redirect to="/rapports-cliniques" />;
                  if (isClinicDelegate) return <Redirect to="/maternite" />;
                  if (isDelegate) return <Redirect to="/emergency" />;
                  if (isCommercial) return <Redirect to="/analytics/summary" />;
                  return <Redirect to="/rapports" />;
               })()}
            </Route>
          </Switch>
        </Main>
      </Route>
    </Switch>
  );
}

export default Router;